import { BaseDataBind } from "./base";

/** 
 * Data bind for element's class attribute. Allows setting default class names via the standard class attribute:
 * <i class="icon" data-bind-class="iconClassName"></i>
 * When ever the value is updated, saved default class names will be included in front of the dynamic data values.
 */
export class ClassNameDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-class';
    public selector = '[data-bind-class]';
    public eventNames = [];

    protected defaultClassNames: string;

    protected getPropertyValue(element: Element)
    {
        this.defaultClassNames = element.className;
        return super.getPropertyValue(element);
    }

    public setElementValue(element: Element, value: any)
    {
        element.className = `${this.defaultClassNames} ${value}`;
    }

    public getElementValue(element: Element)
    {
        return element.className.replace(this.defaultClassNames, '');
    }
}